const LINK_META = {
  GOOGLE: {
    title: 'Google',
    description: 'Leave a review on Google',
    icon: 'bi-google',
  },
  FACEBOOK: {
    title: 'Facebook',
    description: 'Share your experience on Facebook',
    icon: 'bi-facebook',
  },
  YELP: {
    title: 'Yelp',
    description: 'Rate us on Yelp',
    icon: 'bi-yelp',
  },
}

const SocialLink = ({ socialLink }) => {
  const type = (socialLink.linkType || '').toUpperCase()
  const meta = LINK_META[type] || {
    title: socialLink.linkType || 'Review',
    description: 'Leave a public review',
    icon: 'bi-star',
  }

  if (!socialLink.link) return null

  return (
    <a
      className="rep-link"
      href={socialLink.link}
      target="_blank"
      rel="noopener noreferrer"
    >
      <span className="rep-link-icon" aria-hidden="true">
        <i className={`bi ${meta.icon}`} />
      </span>
      <span className="rep-link-text">
        <p className="rep-link-title">{meta.title}</p>
        <p className="rep-link-desc">{meta.description}</p>
      </span>
      <span className="rep-link-arrow" aria-hidden="true">
        <i className="bi bi-arrow-up-right" />
      </span>
    </a>
  )
}

export default SocialLink
